/* eslint-disable eqeqeq */
import {
  dipatchAlreadyExistToast,
  dispatchAddedSuccessToast,
  agentAddedSuccessToast,
  agentAlreadyExistToast,
  somethingWentWrongToast,
  updateStatusToast,
  recordUpdateToast,
  successToast,
} from "../../../components/NotificationToast";
import { ridersList } from "../../orders/actions/orders.actions";
import {
  ADD_AGENT,
  ADD_DISPATCH,
  FETCH_AGENTS,
  FETCH_HOSPITALS,
  FETCH_PIPELINES,
  FETCH_NOTIFICATIONS,
  FETCH_VENDORS,
  LOAD_DASHBOARD_COUNT,
  PREMIUM_LIST,
  RIDER_DETAILS,
  TICKET,
  CYLINDER_LIST,
  CYLINDER_SERIES,
  CYLINDER_SIZE,
  PLANTS_LIST,
  CYLINDER_DETAILS,
  NERVE_CLAIMS,
  NERVE_SEND_CLAIMS,
  CRADLE_REQUEST,
  CRADLE_UPDATE,
  INCIDENT_REPORT,
  INCIDENT_REPORT_POST,
  NOTIFY_NERVE,
  NOTIFY_NERVE_POST,
  DELETE_NERVE_POST,
  SHOW_ALL_PO,
  SHOW_COHORT,
  CREATE_COHORTS,
  SHOW_COHORT_LIST,
  SEND_BULK_MESSAGE,
  ADD_HOSPITALS_COHORT,
  GET_HOSPITAL_CORHOT,
  GET_ALL_QUOTATION,
  SINGLE_QUOTATION,
  POST_QUOTATION,
} from "../../types";
import AdminService from "../services/admin.service";

//Load dashboard count
export const loadDashboardCount = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchDashboardCount();

    dispatch({
      type: LOAD_DASHBOARD_COUNT,
      payload: response.data.data,
    });

    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const sendbulkMessage = (details) => async (dispatch) => {
  try {
    const response = await AdminService.sendCohort(details);
    dispatch({
      type: SEND_BULK_MESSAGE,
      payload: response.data.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const showAllCohort = () => async (dispatch) => {
  try {
    const response = await AdminService.showAllCohort();
    dispatch({
      type: SHOW_COHORT,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const showCohortListhospital = (id) => async (dispatch) => {
  try {
    const response = await AdminService.gethospitalCohort(id);
    dispatch({
      type: SHOW_COHORT_LIST,
      payload: response.data.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const createCohort = (detail) => async (dispatch) => {
  try {
    const response = await AdminService.createCohort(detail);
    dispatch({
      type: CREATE_COHORTS,
      payload: response.data.data,
    });
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const getAllCohortHospital = () => async (dispatch) => {
  try {
    const response = await AdminService.getAllmyHospitalCohort();

    dispatch({
      type: GET_HOSPITAL_CORHOT,
      payload: response.data.data,
    });
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const addHospitalCohortAll = (detail) => async (dispatch) => {
  try {
    const response = await AdminService.addHospitalCohort(detail);
    dispatch({
      type: ADD_HOSPITALS_COHORT,
      payload: response.data.data,
    });
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const showAllPo = () => async (dispatch) => {
  try {
    const response = await AdminService.showAllPo();
    dispatch({
      type: SHOW_ALL_PO,
      payload: response.data.data,
    });
  } catch (error) {
    somethingWentWrongToast();
  }
};

//Load tickets
export const loadTickets = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchTickets();

    dispatch({
      type: TICKET,
      payload: response.data,
    });

    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// fetch hospitals
export const loadHospitals = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchHospitals();

    dispatch({
      type: FETCH_HOSPITALS,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// fetch hospitals
export const loadPipelines = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchPipelines();

    dispatch({
      type: FETCH_PIPELINES,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// fetch notiication
export const loadNotifications = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchNotifications();

    dispatch({
      type: FETCH_NOTIFICATIONS,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// @create new notification
export const addNotification = (details, actions) => async (dispatch) => {
  try {
    const response = await AdminService.createNotifications(details);

    if (response.status === 200) {
      actions.setSubmitting(false);
      actions.resetForm();
      successToast(response.data.message);
      dispatch(loadNotifications());
    }
    return response;
  } catch (error) {
    actions.setSubmitting(false);
    somethingWentWrongToast();
    return error;
  }
};

// @delete a notification
export const deleteNotification = (id) => async (dispatch) => {
  try {
    const response = await AdminService.deleteNotifications(id);

    if (response.status === 200) {
      successToast(response.data.message);
      dispatch(loadNotifications());
    }
    return response;
  } catch (error) {
    somethingWentWrongToast();
    return error;
  }
};

// fetch cylinders
export const loadCylinders = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchCylinder();

    dispatch({
      type: CYLINDER_LIST,
      payload: response.data.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// fetch cylinders
export const loadCylinderDetails = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchCylinderDetails();

    dispatch({
      type: CYLINDER_DETAILS,
      payload: response.data.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// fetch cylinder size
export const loadCylinderSize = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchCylinderSize();

    dispatch({
      type: CYLINDER_SIZE,
      payload: response.data.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// fetch plants
export const loadPlants = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchPlants();

    dispatch({
      type: PLANTS_LIST,
      payload: response.data.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// fetch cylinder series
export const loadSeries = (id) => async (dispatch) => {
  try {
    const response = await AdminService.fetchCylinderSeries(id);

    dispatch({
      type: CYLINDER_SERIES,
      payload: response.data.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// fetch vendors
export const loadVendors = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchVendors();

    dispatch({
      type: FETCH_VENDORS,
      payload: response.data,
    });
    // console.log("vendors", response.data);
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// fetch agents
export const loadAgents = () => async (dispatch) => {
  try {
    const response = await AdminService.fetchAgents();

    dispatch({
      type: FETCH_AGENTS,
      payload: response.data.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// enable agent
export const enableAgent = (id) => async (dispatch) => {
  try {
    const response = await AdminService.enableAgent(id);

    // something went wrong
    if (response?.response?.status === 400) {
      somethingWentWrongToast();
      return;
    }

    if (response.status === 200) {
      updateStatusToast();
      dispatch(loadAgents());
    }
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// disable agent
export const disableAgent = (id) => async (dispatch) => {
  try {
    const response = await AdminService.disableAgent(id);

    // something went wrong
    if (response?.response?.status === 400) {
      somethingWentWrongToast();
      return;
    }

    if (response.status === 200) {
      updateStatusToast();
      dispatch(loadAgents());
    }
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// @create new agent
export const addAgent = (details, actions) => async (dispatch) => {
  try {
    const response = await AdminService.createAgent(details);

    dispatch({
      type: ADD_AGENT,
      payload: response,
    });
    // agent already exist -email
    if (response.status === 200 && response.data.status === 400) {
      actions.setSubmitting(false);
      agentAlreadyExistToast();
      return;
    }
    // agent record created
    else if (response.status === 200) {
      actions.setSubmitting(false);
      actions.resetForm();
      agentAddedSuccessToast();
    }
    return response;
  } catch (error) {
    actions.setSubmitting(false);
    somethingWentWrongToast();
    return error;
  }
};

// @create new dispatch rider
export const addDispatch = (details, actions) => async (dispatch) => {
  try {
    const response = await AdminService.createDispatch(details);
    dispatch({
      type: ADD_DISPATCH,
      payload: response,
    });
    // dispatch rider already exist -id
    if (response.status === 200 && response.data.status === 400) {
      actions.setSubmitting(false);
      dipatchAlreadyExistToast();
      return;
    }

    // rider record created
    if (response.status === 200) {
      actions.setSubmitting(false);
      actions.resetForm();
      dispatchAddedSuccessToast();
    }
    return response;
  } catch (error) {
    actions.setSubmitting(false);
    somethingWentWrongToast();
    return error;
  }
};

// @create new dispatch rider
export const updateDispatch = (details, actions) => async (dispatch) => {
  try {
    const response = await AdminService.updateDispatch(details);

    // something went wrong
    if (response?.response?.status === 400) {
      actions.setSubmitting(false);
      somethingWentWrongToast();
      return;
    }

    // dispatch record created
    if (response.status === 200) {
      actions.setSubmitting(false);
      actions.resetForm();
      recordUpdateToast();
    }
    return response;
  } catch (error) {
    actions.setSubmitting(false);
    somethingWentWrongToast();
    return error;
  }
};

// enable dispatch
export const enableDispatch = (id) => async (dispatch) => {
  try {
    const response = await AdminService.enableDispatch(id);

    // something went wrong
    if (response?.response?.status === 400) {
      somethingWentWrongToast();
      return;
    }

    // dispatch record updated
    if (response.status === 200) {
      updateStatusToast();
      dispatch(ridersList());
    }
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// disable dispatch
export const disableDispatch = (id) => async (dispatch) => {
  try {
    const response = await AdminService.disableDispatch(id);

    // something went wrong
    if (response?.response?.status === 400) {
      somethingWentWrongToast();
      return;
    }

    // trainee record created
    if (response.status === 200) {
      updateStatusToast();
      dispatch(ridersList());
    }
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// @cancel order
export const cancelOrder =
  (details, { setSubmitting, resetForm }) =>
  async (dispatch) => {
    try {
      const response = await AdminService.cancelOrder(details);

      if (response?.response?.status === 400) {
        setSubmitting(false); // Properly handled
        somethingWentWrongToast();
        return;
      }

      if (response.status === 200) {
        setSubmitting(false);
        resetForm(); // Reset form after success
      }
      return response;
    } catch (error) {
      setSubmitting(false);
      somethingWentWrongToast();
      return error;
    }
  };

// update hospital
export const updateHospital = (details, actions) => async (dispatch) => {
  try {
    const response = await AdminService.UpdateHospital(details);
    if (response.staus === 200) {
      actions.setSubmitting(false);
      actions.resetForm();
    }
    return response;
  } catch (error) {
    somethingWentWrongToast();
    return error;
  }
};

// fetch premium lists
export const fetchPremiumList = () => async (dispatch) => {
  try {
    const response = await AdminService.premiumList();

    dispatch({
      type: PREMIUM_LIST,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// update Ticket
export const updateTicket = (details) => async (dispatch) => {
  try {
    const response = await AdminService.updateTicket(details);

    // something went wrong
    if (response?.response?.status === 400) {
      somethingWentWrongToast();
      return;
    }

    // ticket updated
    if (response.status === 200) {
      updateStatusToast();
      dispatch(loadTickets());
    }
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// rider details
export const dispatchDetails = (details) => async (dispatch) => {
  try {
    const response = await AdminService.riderDetails(details);

    dispatch({
      type: RIDER_DETAILS,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

// @create new code
export const addCode = (details, actions) => async (dispatch) => {
  try {
    const response = await AdminService.addCode(details);

    // dispatch({
    //   type: ADD_AGENT,
    //   payload: response,
    // });
    // // agent already exist -email
    // if (response.status === 200 && response.data.status === 400) {
    //   actions.setSubmitting(false);
    //   agentAlreadyExistToast();
    //   return;
    // }
    // // agent record created
    // else if (response.status === 200) {
    //   actions.setSubmitting(false);
    //   actions.resetForm();
    //   agentAddedSuccessToast();
    // }
    return response;
  } catch (error) {
    actions.setSubmitting(false);
    somethingWentWrongToast();
    return error;
  }
};
export const getNerveClaims = () => async (dispatch) => {
  try {
    const response = await AdminService.getNerveClaims();
    dispatch({
      type: NERVE_CLAIMS,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const sendClaimDetails = (details) => async (dispatch) => {
  try {
    const response = await AdminService.sendNerveClaims(details);
    dispatch({
      type: NERVE_SEND_CLAIMS,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const getcradleRequest = () => async (dispatch) => {
  try {
    const response = await AdminService.getcradleRequest();

    dispatch({
      type: CRADLE_REQUEST,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const cradleUpdate = () => async (dispatch) => {
  try {
    const response = await AdminService.postCradleUpdate();
    dispatch({
      type: CRADLE_UPDATE,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};
export const IncidentReport = () => async (dispatch) => {
  try {
    const response = await AdminService.incidentReport();
    dispatch({
      type: INCIDENT_REPORT,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};
export const IncidentReportPost = (details) => async (dispatch) => {
  try {
    const response = await AdminService.incidentReportPost(details);
    dispatch({
      type: INCIDENT_REPORT_POST,
      payload: response,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const NotifyNerve = () => async (dispatch) => {
  try {
    const response = await AdminService.notifyNerve();
    dispatch({
      type: NOTIFY_NERVE,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const notifyNervePost = (detail) => async (dispatch) => {
  try {
    const response = await AdminService.notifyNervePost(detail);
    dispatch({
      type: NOTIFY_NERVE_POST,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const deleteNervePost = (id) => async (dispatch) => {
  try {
    const response = await AdminService.deletePost(id);
    dispatch({
      type: DELETE_NERVE_POST,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const seeAllQuotation = () => async (dispatch) => {
  try {
    const response = await AdminService.seeQuotation();
    dispatch({
      type: GET_ALL_QUOTATION,
      payload: response.data.data,
    });
    // console.log("response", response.data.data);
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const getSingleQuotation = (id) => async (dispatch) => {
  try {
    const response = await AdminService.singleQuotation(id);
    dispatch({
      type: SINGLE_QUOTATION,
      payload: response.data,
    });
    return response;
  } catch (error) {
    somethingWentWrongToast();
  }
};

export const sendQuotation = (id) => async (dispatch) => {
  try {
    const response = await AdminService.sendQuotation(id);
    dispatch({
      type: POST_QUOTATION,
      payload: response.data,
    });
  } catch (error) {
    somethingWentWrongToast();
  }
};
